import { isDefined } from '@app/utils/is';
import React from 'react';

export const useIsAtBottom = (ref?: React.RefObject<HTMLElement>, offset = 0) => {
  const [isAtBottom, setIsAtBottom] = React.useState(false);

  React.useEffect(() => {
    const element = ref?.current;

    if (!isDefined(element)) {
      return;
    }

    const checkIfAtBottom = () => {
      const isElementAtBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + offset;
      setIsAtBottom(isElementAtBottom);
    };

    checkIfAtBottom();

    element.addEventListener('scroll', checkIfAtBottom);

    const resizeObserver = new ResizeObserver(checkIfAtBottom);
    resizeObserver.observe(element);

    return () => {
      element.removeEventListener('scroll', checkIfAtBottom);
      resizeObserver.disconnect();
    };
  }, [ref, offset]);

  return isAtBottom;
};
